var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedItemIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3424 29.3424C75.5525 75.5525 -11.5504 75.5525 34.6576 29.3424C-11.5525 75.5525 -11.5525 -11.5504 34.6576 34.6576C-11.5525 -11.5525 75.5504 -11.5525 29.3424 34.6576C75.5525 -11.5525 75.5525 75.5504 29.3424 29.3424Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedItemIcon3);
export default __webpack_public_path__ + "static/media/recommendedItemIcon3.a936af3cabb3b1abcfc3e3a3dbbe014a.svg";
export { ForwardRef as ReactComponent };